import React from 'react'

interface CalculatorIconProps {
  className?: string
  size?: number
  onClick?: () => void
}

export function CalculatorIcon({
  className = '',
  size = 20,
  onClick,
}: CalculatorIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      onClick={onClick}
    >
      <g opacity="0.6">
        <rect
          x="4.3125"
          y="2.8125"
          width="15.375"
          height="19.125"
          rx="2.4375"
          stroke="currentColor"
          strokeWidth="1.125"
        />
        <rect
          x="6.5625"
          y="5.0625"
          width="10.875"
          height="3.375"
          rx="0.9375"
          stroke="currentColor"
          strokeWidth="1.125"
        />
        <circle
          cx="7.76471"
          cy="12.2647"
          r="1.23529"
          stroke="currentColor"
          strokeWidth="1.05882"
        />
        <circle
          cx="7.76471"
          cy="16.4991"
          r="1.23529"
          stroke="currentColor"
          strokeWidth="1.05882"
        />
        <circle
          cx="12"
          cy="12.2647"
          r="1.23529"
          stroke="currentColor"
          strokeWidth="1.05882"
        />
        <circle
          cx="12"
          cy="16.4991"
          r="1.23529"
          stroke="currentColor"
          strokeWidth="1.05882"
        />
        <circle
          cx="16.2353"
          cy="12.2647"
          r="1.23529"
          stroke="currentColor"
          strokeWidth="1.05882"
        />
        <circle
          cx="16.2353"
          cy="16.4991"
          r="1.23529"
          stroke="currentColor"
          strokeWidth="1.05882"
        />
      </g>
    </svg>
  )
}
